import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GitCompareArrows, Flag, Trash2, UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";
import { t } from "@/lib/i18n";

const ReportDialog = ({ p, onClose }) => {
  const [reason, setReason] = useState("");
  const send = async () => {
    try {
      await api.post(`/persons/${p.person_id}/delete-request`, { reason });
      toast.success("Request sent — needs 5 family approvals");
      onClose();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="report-dialog">
        <DialogHeader><DialogTitle className="font-serif">Report {p.name} as a wrong entry</DialogTitle></DialogHeader>
        <p className="text-sm text-[#52635B]">The entry is removed once 5 approved family members agree.</p>
        <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="What is wrong? e.g. duplicate, not part of the family…" data-testid="report-reason-input" />
        <Button onClick={send} disabled={!reason.trim()} className="rounded-full bg-[#C62828] hover:bg-[#A61F1F]" data-testid="report-submit-btn">Send removal request</Button>
      </DialogContent>
    </Dialog>
  );
};

export const LineageActions = ({ p }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [report, setReport] = useState(false);
  const myId = user?.person?.status === "approved" ? user.person.person_id : null;
  const del = async () => {
    if (!window.confirm(`Delete ${p.name} from the tree? This cannot be undone.`)) return;
    try { await api.delete(`/persons/${p.person_id}`); toast.success("Removed"); navigate("/"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="flex flex-wrap gap-3">
      {myId !== p.person_id && (
        <Button asChild className="rounded-full bg-[#1E3A2B] hover:bg-[#162C20]" data-testid="how-related-btn">
          <Link to={`/relations?${myId ? `a=${myId}&` : ""}b=${p.person_id}`}><GitCompareArrows className="w-4 h-4 mr-2" />{myId ? t("How am I related?") : t("Find relation")}</Link>
        </Button>
      )}
      <Button asChild variant="outline" className="rounded-full" data-testid="add-relative-btn">
        <Link to={`/join?relative=${p.person_id}`}><UserPlus className="w-4 h-4 mr-2" />{t("Add a relative")}</Link>
      </Button>
      {user?.is_admin ? (
        <Button variant="outline" onClick={del} className="rounded-full text-[#C62828]" data-testid="admin-delete-person-btn"><Trash2 className="w-4 h-4 mr-2" />{t("Delete entry")}</Button>
      ) : user?.can_vote ? (
        <Button variant="outline" onClick={() => setReport(true)} className="rounded-full text-[#C62828]" data-testid="report-wrong-btn"><Flag className="w-4 h-4 mr-2" />{t("Report wrong entry")}</Button>
      ) : null}
      {report && <ReportDialog p={p} onClose={() => setReport(false)} />}
    </div>
  );
};
